import flatMap from 'lodash/flatMap';
import pick from 'lodash/pick';
import uniq from 'lodash/uniq';

import { createSelector } from 'reselect';
import { getOfferIdsByFilter } from './getOfferIdsByFilter';
import { getActiveFilters } from './getActiveFilters';

export const getTotalAvailableCount = createSelector(getOfferIdsByFilter, getActiveFilters, (result, activeFilters) => {
  if (!activeFilters.length) return result.all.length;

  const offersByFilter = pick(result, activeFilters);
  const allOfferIds = flatMap(offersByFilter, (offer) => offer);
  const uniqueOfferIds = uniq(allOfferIds);

  return uniqueOfferIds.length;
});
